const apiURL = process.env.REACT_APP_API_URL;

export async function updateStatusInstance(
  OldStatus,
  CurrentStatus,
  NewStatus,
  InstanceId,
  ListOnly,
  token
) {
  const apiUrl = `${apiURL}/admin/document/statusupdate`;
  try {
    const response = await fetch(apiUrl, {
      method: "PATCH",
      headers: {
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        OldStatus: OldStatus,
        CurrentStatus: CurrentStatus,
        NewStatus: NewStatus,
        InstanceId: InstanceId,
        ListOnly: ListOnly,
      }),
    });

    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    return data.message.items;
  } catch (error) {
    console.error("Error fetching documents:", error);
    throw error;
  }
}
